import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const WarnDocumentationStep: React.FC = () => {
  const { goNext, goBack } = useWizard();
  const [title, setTitle] = useState('Husk dokumentation');
  const [body, setBody] = useState<string[]>([]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.warn_documentation).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body) {setBody(c.body || []);}
    });
  }, []);

  return (
    <StepContainer title={title}>
      {body.length > 0 ? (
        <InfoBox type="info">
          {body.map((p, i) => <p key={i}>{p}</p>)}
        </InfoBox>
      ) : (
        <InfoBox type="info">
          <p>Medbring dokumentation for dansk statsborgerskab (fx statsborgerretsbevis) hvis du har haft tidligere statsborgerskab.</p>
        </InfoBox>
      )}
      <NavigationButtons onBack={goBack} onNext={goNext} />
    </StepContainer>
  );
};

export default WarnDocumentationStep;
